import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const REGIONS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('REGIONS');
export const REGIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	REGIONS_CRUD_ACTION_CONSTANTS
);
